import Vue from 'vue';
import CartProductQuantity from '@/modules/product/components/ProductQuantity.vue';
import { mapState, mapActions } from 'vuex';
import { SelectionType } from '@/modules/product/model/ProductDto';
import VariantSelectedPreview from '@/modules/product/components/VariantSelectedPreview.vue';
export default Vue.extend({
    components: {
        CartProductQuantity,
        VariantSelectedPreview,
    },
    props: {
        item: Object,
        toast: Boolean,
        itemId: {
            type: Number,
            default: null,
        },
    },
    data() {
        return {
            SelectionType: SelectionType,
            disableQuantityButton: false,
        };
    },
    computed: {
        ...mapState('cartModule', ['cartMessages']),
        ...mapState('checkoutModule', [
            'promoCodes',
            'appliedOrderPromoCode',
        ]),
        ...mapState('cartModule', ['productPromoCodes']),
    },
    methods: {
        ...mapActions('cartModule', ['updateItemQuantity', 'removeItem']),
        ...mapActions('checkoutModule', ['callApplyOrderPromoCode']),
        openProductPromoModal() {
            this.$bvModal.show(`productPromoPreview-${this.itemId}`);
        },
        checkIfCodeAvailable(uuidList, uuid) {
            if (!Array.isArray(uuidList))
                return false;
            return uuidList.includes(uuid);
        },
        checkIfAnyCodeAvailable() {
            let result = false;
            for (const code of this.promoCodes) {
                if (this.checkIfCodeAvailable(code.applicable_product_unit_uuids, this.item.selectedUnit.uuid)) {
                    result = true;
                }
            }
            return result;
        },
        checkIfCodeIsInUse(code) {
            const exists = this.productPromoCodes.some(p => (p.productUnitUuid !== this.item.selectedUnitUuid && p.promoCode === code));
            if (exists) {
                return true;
            }
            return false;
        },
        checkIfAppliedPromoCode(code = null) {
            if (code) {
                const exists = this.productPromoCodes.some(p => (p.promoCode === code && p.productUnitUuid == this.item.selectedUnitUuid && p.discountAmount > 0));
                if (exists) {
                    return true;
                }
            }
            else {
                const exists = this.productPromoCodes.some(p => (p.productUnitUuid == this.item.selectedUnitUuid && p.discountAmount > 0));
                if (exists) {
                    return true;
                }
            }
            return false;
        },
        getProductDiscountAmount() {
            const existing = this.productPromoCodes.find(p => p.productUnitUuid === this.item.selectedUnitUuid);
            if (existing) {
                return existing.discountAmount;
            }
            else {
                return 0;
            }
        },
        getProductPromoCode() {
            const existing = this.productPromoCodes.find(p => p.productUnitUuid === this.item.selectedUnitUuid);
            if (existing) {
                return existing.promoCode;
            }
            else {
                return null;
            }
        },
        nl2br(val) {
            if (val == null)
                return '';
            return String(val).replace(/\r\n|\n/g, '<br>');
        },
        removeProductPromoCode(code) {
            this.$store.commit('cartModule/removeProductPromoCode', {
                productUnitUuid: this.item.selectedUnitUuid,
                promoCode: code,
            });
            this.callApplyOrderPromoCode();
        },
        async applyProductPromoCode(code) {
            const existing = this.getProductPromoCode();
            if (existing) {
                this.$store.commit('cartModule/removeProductPromoCode', {
                    productUnitUuid: this.item.selectedUnitUuid,
                    promoCode: existing,
                });
            }
            this.$store.commit('cartModule/addOrUpdateProductPromoCodes', {
                productUnitUuid: this.item.selectedUnitUuid,
                promoCode: code,
                discountAmount: 0
            });
            this.callApplyOrderPromoCode();
        },
        cartRemoveItem() {
            this.removeItem(this.item).then(() => {
                if (this.cartMessages) {
                    this.$bvToast.toast(this.cartMessages.join(', '), {
                        variant: 'info',
                    });
                }
            });
        },
        onQuantitySelected(cartItem, newQuantity) {
            this.disableQuantityButton = true;
            this.updateItemQuantity({ ...cartItem, quantity: newQuantity })
                .then(() => {
                if (this.cartMessages) {
                    this.$bvToast.toast(this.cartMessages.join(', '), {
                        variant: 'info',
                    });
                }
            })
                .catch((error) => {
                console.log(error);
                this.$bvToast.toast(error.data.message, { variant: 'danger' });
            })
                .finally(() => {
                setTimeout(() => {
                    this.disableQuantityButton = false;
                }, 100);
            });
        },
    },
    created() {
    },
});
